import ErrorIcon from '@mui/icons-material/Error';
import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const classes = {
	errorIcon: {
		color: (theme) => theme.palette.text.primary,
	},
	errorContainer: {
		backgroundColor: (theme) => theme.palette.background.default,
	},
	errorText: {
		margin: (theme) => theme.spacing(1),
		marginBottom: (theme) => theme.spacing(3) /* eslint-disable-line no-magic-numbers */,
		color: (theme) => theme.palette.text.primary,
	},
	retryButton: {
		textTransform: 'uppercase',
	},
};

/**
 * @param {function} onRetry function to retry the action
 * @param {string} errorText translated error text to display
 * @returns The rendered component
 */
const ErrorFeedbacks = ({ onRetry, errorText }) => {
	const { t } = useTranslation('candidate-feedback');

	return (
		<Box
			sx={classes.errorContainer}
			width="100%"
			height="100%"
			display="flex"
			justifyContent="center"
			alignItems="center"
			flexDirection="column"
		>
			<ErrorIcon sx={classes.errorIcon} size="large" />
			<Typography variant="body2" sx={classes.errorText}>
				{errorText}
			</Typography>
			<Button variant="contained" color="primary" sx={classes.retryButton} onClick={onRetry}>
				{t('retry_text')}
			</Button>
		</Box>
	);
};

export default ErrorFeedbacks;
